import { Component, OnInit, Output } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-lib-browser',
  templateUrl: './lib-browser.component.html',
  styleUrls: ['./lib-browser.component.css']
})
export class LibBrowserComponent implements OnInit {
  nodes;
  options = {};
  assetsPath = '';
  search = true;
  @Output() selectedAsset: EventEmitter<any> = new EventEmitter();

  constructor(private http: HttpClient, private router: Router) { }

  ngOnInit() {
    let url = this.router.url;
    if (url.indexOf('search') < 0)
      this.search = false;
    this.http.get<any>('src/assets/json/library.json').subscribe(
      data => {
        let tempJson = JSON.stringify(data).split("subFolders").join("children");
        this.nodes = JSON.parse(tempJson);
      }, error => {
        console.log(error);
      }
    )
  }

  onInit(tree) {
    console.log(tree);
  }

  // public logEvent(e: NodeEvent): void {
  //   console.log(e);
  // }

  onNodeToggled(event) {
    console.log(event);
    console.log(`The ${event.node.data.name} node is toggled`);
  }

  onNodeSelect(event) {
    // console.log(event);
    let child = event.node;
    this.assetsPath = '';
    while (null != child.parent && child.parent.data.name) {
      this.assetsPath += `,${child.parent.data.name}`;
      child = child.parent;
    }
    // console.log(this.assetsPath);
    console.log(`The ${event.node.data.name} node is Clicked`)
    event.node.data.assetsPath = event.node.data.name + this.assetsPath;
    this.selectedAsset.emit(event.node.data);
  }

  get state() {
    return localStorage.treeState && JSON.parse(localStorage.treeState);
  }
  set state(state) {
    localStorage.treeState = JSON.stringify(state);
  }

  get state1() {
    return localStorage.treeState1 && JSON.parse(localStorage.treeState1);
  }
  set state1(state1) {
    localStorage.treeState1 = JSON.stringify(state1);
  }


}
